// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--PUWtP";
export var footerTop = "styles-module--footer-top--xWxde";
export var footerLogoImage = "styles-module--footer-logo-image--2o0cX";
export var footerLogo = "styles-module--footer-logo--lAPok";
export var footerBlockLinks = "styles-module--footer-block-links--g+WnY";
export var footerBlockLinksLink = "styles-module--footer-block-links-link--deAEG";
export var footerSocialLinks = "styles-module--footer-social-links--Ioia4";
export var footerBottom = "styles-module--footer-bottom--0ERo7";
export var footerBottomContainer = "styles-module--footer-bottom-container--uUFZN";